export const ZENDESK_GUIDE_URL = '/zendesk-jwt-sso';
